import { TFunction } from 'i18next';
import { IAppException } from '@jaam/commons/exceptions';
import { FieldPath, UseFormSetError } from 'react-hook-form';
import { AppErrorResponse } from './error.type'; // adjust path
import { FieldValues } from 'react-hook-form';

/**
 * Translate field-specific error messages.
 */
export function translateErrorMessages(
  error: IAppException,
  t: TFunction,
): AppErrorResponse {
  const translatedDetails = error.details.map((detail) => {
    const translationKey = `${detail.code}`;

    return {
      ...detail,
      translatedMessage:
        t(translationKey, detail.params ?? {}) || detail.message || detail.code,
    };
  });

  return {
    ...error,
    translatedMessage: t(error.code) || error.message,
    details: translatedDetails,
  };
}

/**
 * Apply field-level API errors to react-hook-form.
 */
export function applyFieldErrors<TFieldValues extends FieldValues>(
  error: AppErrorResponse,
  setError: UseFormSetError<TFieldValues>,
) {
  error.details.forEach((detail) => {
    if (detail.field) {
      try {
        setError(detail.field as FieldPath<TFieldValues>, {
          type: 'manual',
          message: detail.translatedMessage,
        });
      } catch (e) {
        // field might not exist in the form
      }
    }
  });
}
